import React from 'react';
import { Card } from '@uhg-abyss/web/ui/Card';
import { Signature } from '../Attestation/Inputs/Signature';

export const SignatureBox = () => {
  return (
    <Card header="Signature">
      <Card.Section>
        <Signature />
      </Card.Section>
    </Card>
  );
};
